/* eslint-disable no-console */
import appVersion from "../appVersion";
import sanitizeTraits from "../sanitizeTraits";
import { getEnv } from "../env";
const {
  NODE_ENV,
  REACT_APP_BUGSNAG_API_KEY,
  REACT_APP_BUGSNAG_RELEASE_STAGE,
  REACT_APP_DISABLE_BUGSNAG,
  STACK,
} = getEnv();
function shouldLoadBugsnag() {
  return (
    NODE_ENV === "production" &&
    typeof REACT_APP_BUGSNAG_API_KEY === "string" &&
    REACT_APP_BUGSNAG_API_KEY.length > 0 &&
    REACT_APP_DISABLE_BUGSNAG !== "true"
  );
}
let notify = () => {};
let currentUserUid;
let currentUserTraits;
const identify = (userUid, traits) => {
  currentUserUid = userUid;
  currentUserTraits = sanitizeTraits(traits);
};
if (NODE_ENV === "development")
  notify = (error, opts) => {
    console.log(
      "%c[bugsnag.notify] %cerror.message=%c" +
        error.message +
        `%c. ${opts ? "opts=" : ""}`,
      "color:cornflowerblue",
      "color:slategrey",
      "color:black",
      "color:slategrey",
      opts
    );
    console.log(
      "%cThe full error displayed next would be sent to Bugsnag.",
      "color:slategrey"
    );
    console.warn(error);
  };
const client = {
  notify: (error, opts) => {
    notify(error, opts);
  },
  use: (_plugin, ..._args) => {},
  getPlugin: (_name) => {},
};
if (shouldLoadBugsnag()) {
  // tslint:disable-next-line:no-var-requires
  const bugsnag = require("@bugsnag/browser").default;
  const bugsnagClient = bugsnag({
    apiKey: REACT_APP_BUGSNAG_API_KEY,
    appVersion: appVersion(),
    appType: "web",
    releaseStage:
      typeof REACT_APP_BUGSNAG_RELEASE_STAGE === "string" &&
      REACT_APP_BUGSNAG_RELEASE_STAGE.length > 0
        ? REACT_APP_BUGSNAG_RELEASE_STAGE
        : STACK || "unknown",
    beforeSend: (report) => {
      if (currentUserUid && currentUserTraits)
        report.user = { ...currentUserTraits, uid: currentUserUid };
      else if (currentUserUid) report.user = { uid: currentUserUid };
    },
  });
  notify = (error, opts) => bugsnagClient.notify(error, opts);
  client.use = (...args) => bugsnagClient.use(...args);
  client.getPlugin = (...args) => bugsnagClient.getPlugin(...args);
}
export default client;
export { identify };
